import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=70d9a652&"
import script from "./Table.js?vue&type=script&lang=js&"
export * from "./Table.js?vue&type=script&lang=js&"
import style0 from "./Table.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports